<script setup lang="ts">
import { useId } from 'radix-vue'
import { Label } from '../Label'
import Checkbox from './Checkbox.vue'

defineProps<{
    options: {
        label: string
        value: string
    }[]
}>()

const emit = defineEmits<{
    toggle: [value: string, checked: boolean]
}>()

const id = useId('checkbox-group')

const modelValue = defineModel<string[]>({
    default: () => [],
})
</script>

<template>
    <div v-for="option in options" :key="option.value" class="flex flex-row items-center space-x-2">
        <Checkbox
            :checked="modelValue.includes(option.value)"
            :id="`${id}-${option.value}`"
            @update:checked="
                (checked) => {
                    modelValue = checked
                        ? [...modelValue, option.value]
                        : modelValue.filter((value) => value !== option.value)
                    emit('toggle', option.value, checked)
                }
            "
        />
        <Label :for="`${id}-${option.value}`" class="font-medium">
            {{ option.label }}
        </Label>
    </div>
</template>
